import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { EpcotConfigService } from 'packages/sports/web/app/src/common/epcot-config.service';
import { Observable } from 'rxjs';

import { ISystemSlipTypeInfo } from '../../models';
import SystemBetTypesService, { SystemTypeOrder } from '../../services/types/system-bet-types.service';

@Component({
    selector: 'bs-system-bet-types-list',
    templateUrl: './system-bet-types-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export default class SystemBetTypesListComponent {
    @Input() oddsDisplayFormat: OddsDisplayFormat;

    readonly availableTypes$: Observable<ISystemSlipTypeInfo[]>;
    readonly isEpcotEnabled: boolean;

    constructor(typesService: SystemBetTypesService, epcotConfigService: EpcotConfigService) {
        this.availableTypes$ = typesService.getAvailableSystemTypes$(SystemTypeOrder.ByBetCount);
        this.isEpcotEnabled = epcotConfigService.isEnabled();
    }
}
